import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { I18nProvider } from './i18n';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import Cities from './pages/Cities';
import CityDetail from './pages/CityDetail';
import Simulators from './pages/Simulators';
import Strategies from './pages/Strategies';
import Accompagnement from './pages/Accompagnement';
import NetCalculator from './pages/NetCalculator';
import Agencies from './pages/Agencies';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Glossary from './pages/Glossary';
import Neighborhoods from './pages/Neighborhoods';
import InvestorProfile from './pages/InvestorProfile';
import Comparator from './pages/Comparator';
import MentionsLegales from './pages/MentionsLegales';
import NotFound from './pages/NotFound';
import WhatsAppButton from './components/ui/WhatsAppButton';
import CookieBanner from './components/ui/CookieBanner';

export default function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Header />
          <main style={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/villes" element={<Cities />} />
              <Route path="/villes/:slug" element={<CityDetail />} />
              <Route path="/simulateurs" element={<Simulators />} />
              <Route path="/strategies" element={<Strategies />} />
              <Route path="/accompagnement" element={<Accompagnement />} />
              <Route path="/calculateur-net" element={<NetCalculator />} />
              <Route path="/agences" element={<Agencies />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/glossaire" element={<Glossary />} />
              <Route path="/quartiers" element={<Neighborhoods />} />
              <Route path="/profil-investisseur" element={<InvestorProfile />} />
              <Route path="/comparateur" element={<Comparator />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <WhatsAppButton />
        <CookieBanner />
      </BrowserRouter>
    </I18nProvider>
  );
}
